export enum LevelComponent {
    SUITCASE = 'suitcase',
    BOOSTER_TNT = 'boosterTNT',
    BOOSTER_BULLSEYE = 'boosterBullseye',
    BOOSTER_SHUFFLE = 'boosterShuffle',
    SETTINGS = 'settings',
    BOOSTER_PLUS_FIVE = 'boosterPlusFive',
    BONUS_STREAK = 'bonusStreak',
    BOOSTER_UNDO = 'boosterUndo',
    BOOSTER_JOKER = 'boosterJoker',
}
